import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SkillProgressCard = ({ skills }) => {
  const navigate = useNavigate();

  const getSkillColor = (level) => {
    if (level >= 80) return 'bg-green-500';
    if (level >= 50) return 'bg-blue-500';
    return 'bg-amber-500';
  };

  return (
    <div className="bg-card rounded-xl p-6 shadow-md border border-border">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-foreground flex items-center gap-2">
          <Icon name="TrendingUp" size={24} className="text-primary" />
          Skill Development
        </h2>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/skills-development-academy')}
          iconName="ArrowRight"
          iconPosition="right"
        >
          View All
        </Button>
      </div>
      <div className="space-y-4">
        {skills?.map((skill, index) => (
          <div key={index} className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Icon name={skill?.icon} size={18} className="text-primary" />
                <span className="font-medium text-foreground">{skill?.name}</span>
              </div>
              <span className="text-sm font-semibold text-primary">{skill?.level}%</span>
            </div>
            <div className="relative h-2 bg-muted rounded-full overflow-hidden">
              <div
                className={`absolute top-0 left-0 h-full ${getSkillColor(skill?.level)} rounded-full transition-all`}
                style={{ width: `${skill?.level}%` }}
              />
            </div>
            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <span>{skill?.hoursCompleted}h completed</span>
              <span>{skill?.certificationsEarned} certifications</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 rounded-lg bg-primary/5 border border-primary/20">
        <div className="flex items-start gap-3">
          <Icon name="Lightbulb" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-foreground mb-1">
              Recommended Next Step
            </p>
            <p className="text-sm text-muted-foreground">
              Complete "Advanced Project Management" to unlock leadership opportunities
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillProgressCard;